type IEnvConfig = {
    apiEnv: string;
    devToolbarDisabled: boolean;
};

type IEnvsConfig = Record<NonNullable<ImportMetaEnv['CDII_ENV']>, IEnvConfig>;

const envs: IEnvsConfig = {
    test: {
        apiEnv: 'test',
        devToolbarDisabled: false,
    },
    visualTest: {
        apiEnv: 'localhost:apiMock',
        devToolbarDisabled: true,
    },
    dynamic: {
        apiEnv: 'development',
        devToolbarDisabled: false,
    },
    development: {
        apiEnv: 'development',
        devToolbarDisabled: false,
    },
    staging: {
        apiEnv: 'staging',
        devToolbarDisabled: false,
    },
    demo: {
        apiEnv: 'demo',
        devToolbarDisabled: true,
    },
    preprod: {
        apiEnv: 'preprod',
        devToolbarDisabled: true,
    },
    production: {
        apiEnv: 'production',
        devToolbarDisabled: true,
    },
    prod: {
        apiEnv: 'production',
        devToolbarDisabled: true,
    },
};

export default envs;
